import isNil from 'lodash/isNil';
import React, { type ReactNode } from 'react';

import * as D from '../deps';

import BackstageTrackListItem from './BackstageTrackListItem';

export interface IBackstageTrackListOwnProps {
  tracks: $TSFixMe;
  numPlaceholders?: number;
  playablePandoraId?: string;
  shareParentSource?: $TSFixMe;
  isAlbumBSP?: boolean;
  isCompilation?: boolean;
  isAlbumCollected?: boolean;
  isAlbumRadioOnly?: boolean;
  elementHeight: number;
  showArtistName: boolean;
}

export type IBackstageTrackListProps = IBackstageTrackListOwnProps;

class BackstageTrackList extends React.Component<IBackstageTrackListProps> {
  validatePropKey = (prop: $TSFixMe): $TSFixMe => {
    return !isNil(prop);
  };

  generateListKey = (): $TSFixMe => {
    return [
      // when any of these values change, it will ensure BackstageItemList gets rerendered
      // so that the item's source card options get updated.
      this.props.playablePandoraId,
      this.props.isAlbumBSP,
      this.props.isCompilation,
      this.props.isAlbumCollected,
      this.props.isAlbumRadioOnly,
      this.props.showArtistName,
    ]
      .filter(this.validatePropKey)
      .join(':');
  };

  // @ts-expect-error TS(6133) FIXME: 'pandoraId' is declared but its value is never rea... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  generateListItemProps = (_pandoraId, index) => {
    return {
      hasBorderTopBottom: true,
      isAlbumBSP: this.props.isAlbumBSP,
      isAlbumCollected: this.props.isAlbumCollected,
      isAlbumRadioOnly: this.props.isAlbumRadioOnly,
      isCompilation: this.props.isCompilation,
      playablePandoraId: this.props.playablePandoraId,
      playIndex: index,
      shareParentSource: this.props.shareParentSource,
      showArtistName: this.props.showArtistName,
    };
  };

  render(): ReactNode {
    return (
      <D.BackstageItemList
        listKey={this.generateListKey()}
        sourceItems={this.props.tracks}
        elementHeight={this.props.elementHeight}
        generateListItemProps={this.generateListItemProps}
        // @ts-expect-error TS(2322) FIXME: Type 'ConnectedComponent<{ (props: any): Element; ... Remove this comment to see the full error message
        listItemComponent={BackstageTrackListItem}
        numPlaceholders={this.props.numPlaceholders}
      />
    );
  }
}

export default BackstageTrackList;
